import Collapse from '@material-ui/core/Collapse'
import React from "react"
import Button from "../../components/UI/Button/Button"
import Input from "../../components/UI/Input/Input"
import LocalSearch from "../../components/UI/Search/Search"
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import FetchData from "../../shared/fetchData"
import { updateObject } from "../../shared/utility"

const ElockChanges = () => {

    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [changes, setChanges] = React.useState([])
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, []);

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "searchText1": searchParams.description.value,
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/contents/getElockChanges'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.changes)
                    pushData(newList)
                    setChanges(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'date',
                header: "تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'description',
                header: "تغییرات",
                align: 'center',
            },
            {
                accessorKey: 'version',
                header: "نسخه",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                date: d.date,
                description: d.description,
                version: d.version,
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }



    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    return (
        <>
            <Collapse in={true}>
                {loading ? <Spinner /> : ''}
                <LocalSearch class="orders-search" form={form} />

                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} data={changes} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={300} loading={loading} />
                    :
                    <Table hasDetails={false} data={changes} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={300} loading={loading} />
                }
            </Collapse>
        </>
    )
}

export default ElockChanges;